<template>
  <label class="sui-toggle" :class="{'sui-toggle--disabled':disabled}">
    <input
      class="sui-toggle__box-area"
      type="checkbox"
      v-model="localValue"
      :disabled="disabled"
      :class="{'sui-toggle--disabled':disabled}"
    >
    <span class="sui-toggle__box-slider round" :class="{'sui-toggle--disabled':disabled}"></span>
  </label>
</template>
<script>
import DatasetBase from "~common/components/form/SuiDatasetBase/SuiDatasetBase";
/**
 * 이름 : SuiToggle
 * 설명 : 토글 스위치 컴포넌트
 * 최종 수정 일시 : 2018 - 09 - 10
 */
export default {
  name: "SuiToggle",
  extends: DatasetBase,
  props: {
    value: {
      type: Boolean,
      default: false
    },
    disabled: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      localValue: this.value
    };
  },
  watch: {
    value(newValue) {
      this.localValue = newValue;
    },
    localValue(newValue) {
      this.$emit("input", newValue);
    }
  },
  mounted() {
    this.bindDataset();

    if (!this.value) return;

    this.localValue(this.value);
  },
  beforeDestroy() {
    this.unbindDataset();
  },
  methods: {
    onDatasetSelectionChanged(selectedValue, selectedRow) {
      this.localValue(selectedValue);
    },
  },
};
</script>
<style>
</style>
